/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveawaystats_Giveaways1Inputs */

const id_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway`)
};

const ms_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberian`)
};

const da_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const de_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const en_us2_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const es_es2_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regalos`)
};

const es_mx2_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regalos`)
};

const fil_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Giveaway`)
};

const fr_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuités`)
};

const it_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway`)
};

const hu_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajándékok`)
};

const nl_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const no_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const pl_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozdania`)
};

const pt_br2_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const pt_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas grátis`)
};

const ro_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte gratuite`)
};

const fi_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaisjaot`)
};

const sv_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utlottningar`)
};

const vi_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lượt tặng`)
};

const tr_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedava Oyunlar`)
};

const cs_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výprodeje`)
};

const bg_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатни игри`)
};

const ru_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Раздачи`)
};

const uk_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Роздачі`)
};

const ar_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الهدايا`)
};

const hi_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गिवअवे`)
};

const th_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ของแจกฟรี`)
};

const ja_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配布数`)
};

const zh_cn2_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const zh_hant1_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const ko_components_giveawaystats_giveaways1 = /** @type {(inputs: Components_Giveawaystats_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

/**
* | output |
* | --- |
* | "Giveaways" |
*
* @param {Components_Giveawaystats_Giveaways1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveawaystats_giveaways1 = /** @type {((inputs?: Components_Giveawaystats_Giveaways1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveawaystats_Giveaways1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveawaystats_giveaways1(inputs)
	if (locale === "ms") return ms_components_giveawaystats_giveaways1(inputs)
	if (locale === "da") return da_components_giveawaystats_giveaways1(inputs)
	if (locale === "de") return de_components_giveawaystats_giveaways1(inputs)
	if (locale === "en-US") return en_us2_components_giveawaystats_giveaways1(inputs)
	if (locale === "es-ES") return es_es2_components_giveawaystats_giveaways1(inputs)
	if (locale === "es-MX") return es_mx2_components_giveawaystats_giveaways1(inputs)
	if (locale === "fil") return fil_components_giveawaystats_giveaways1(inputs)
	if (locale === "fr") return fr_components_giveawaystats_giveaways1(inputs)
	if (locale === "it") return it_components_giveawaystats_giveaways1(inputs)
	if (locale === "hu") return hu_components_giveawaystats_giveaways1(inputs)
	if (locale === "nl") return nl_components_giveawaystats_giveaways1(inputs)
	if (locale === "no") return no_components_giveawaystats_giveaways1(inputs)
	if (locale === "pl") return pl_components_giveawaystats_giveaways1(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveawaystats_giveaways1(inputs)
	if (locale === "pt") return pt_components_giveawaystats_giveaways1(inputs)
	if (locale === "ro") return ro_components_giveawaystats_giveaways1(inputs)
	if (locale === "fi") return fi_components_giveawaystats_giveaways1(inputs)
	if (locale === "sv") return sv_components_giveawaystats_giveaways1(inputs)
	if (locale === "vi") return vi_components_giveawaystats_giveaways1(inputs)
	if (locale === "tr") return tr_components_giveawaystats_giveaways1(inputs)
	if (locale === "cs") return cs_components_giveawaystats_giveaways1(inputs)
	if (locale === "bg") return bg_components_giveawaystats_giveaways1(inputs)
	if (locale === "ru") return ru_components_giveawaystats_giveaways1(inputs)
	if (locale === "uk") return uk_components_giveawaystats_giveaways1(inputs)
	if (locale === "ar") return ar_components_giveawaystats_giveaways1(inputs)
	if (locale === "hi") return hi_components_giveawaystats_giveaways1(inputs)
	if (locale === "th") return th_components_giveawaystats_giveaways1(inputs)
	if (locale === "ja") return ja_components_giveawaystats_giveaways1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveawaystats_giveaways1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveawaystats_giveaways1(inputs)
	return ko_components_giveawaystats_giveaways1(inputs)
});
export { components_giveawaystats_giveaways1 as "components.giveawayStats.giveaways" }